

<ng-template let-selectableData #creditCardPayOptionTmplt [appControlTemplate]="'creditCardPayOptionTmplt'">
    <box class="pay-option-item">
        <span>{{ selectableData?.text.description | translate }}</span>
        <span class="pay-amount">{{selectableData?.text.value | currency : selectableData?.text.currency : '' }}</span>
    </box>
</ng-template>

<ng-template let-selectableData #videoCaptureBtnTmplt [appControlTemplate]="'videoCaptureBtnTmplt'">
    <span>Record video</span>
</ng-template>





